import { useMemo, useCallback } from "react";
import { useRouter } from "next/router";

export const useSort = (sortOptionData) => {
  const router = useRouter();

  const setSelectedSortValue = useMemo(() => {
    const sortBy = router.query.sortBy;
    const sortOption = sortOptionData.find((option) => option.value === sortBy);

    if (sortOption) {
      return sortOption;
    }

    return null;
  }, [router.query.sortBy, sortOptionData]);

  const sortData = useCallback(
    (data) => {
      const previousQuery = { ...router.query };

      const newQuery = {
        ...previousQuery,
        sortBy: data.value,
        page: 1,
      };

      router.push(
        {
          pathname: router.pathname,
          query: { ...newQuery },
        },
        undefined,
        { shallow: true }
      );
    },
    [router]
  );

  return { setSelectedSortValue, sortData };
};
